// src/components/ui/AppButton.jsx
import React from 'react';
import Button from '@mui/material/Button';

const AppButton = React.forwardRef(function AppButton(
    { variant, color, sx, ...props },
    ref
) {
    return (
        <Button
            ref={ref}
            variant={variant ?? 'contained'}
            color={color ?? 'primary'}
            disableElevation
            sx={sx}
            {...props}
        />
    );
});

export default AppButton;
